module.exports = __webpack_public_path__ + "img/header-engagementRings025Carat.4edc957.jpg";